import React from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

function ContentWork() {
    return (
        <div className="skolkovo-kids__content-work">
            <div className="skolkovo-kids__content-work-inner">
                <div className="skolkovo-kids__content-work-title">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        Работа с контентом
                    </ScrollAnimation>
                </div>

                <div className="skolkovo-kids__content-work-text">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        &laquo;Дети в&nbsp;Сколково&raquo; общаются на&nbsp;языке дружбы, знаний
                        и&nbsp;технологий. Основная задача контента&nbsp;&mdash; убедить родителей,
                        что они могут доверить ребенка в&nbsp;руки &laquo;Сколково&raquo;,
                        и&nbsp;что детям будет интересно и&nbsp;полезно это погружение в&nbsp;мир
                        технологий и&nbsp;предпринимательства.
                    </ScrollAnimation>
                </div>

                <div className="skolkovo-kids__content-work-text">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        Наша команда также провела конкурентный анализ и&nbsp;предложила новый
                        подход к&nbsp;ведению сообщества, который коснулся визуального
                        и&nbsp;контентного аспектов.
                    </ScrollAnimation>
                </div>

                <div className="skolkovo-kids__content-work-list">
                    <div className="skolkovo-kids__content-work-text skolkovo-kids__content-work-text--accent">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            Что улучшили:
                        </ScrollAnimation>
                    </div>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="skolkovo-kids__content-work-text skolkovo-kids__content-work-text--item">
                            изменили Tone of&nbsp;voice;
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="skolkovo-kids__content-work-text skolkovo-kids__content-work-text--item">
                            внедрили регулярный постинг;
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="skolkovo-kids__content-work-text skolkovo-kids__content-work-text--item">
                            закрепили четкую структуру поста;
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="skolkovo-kids__content-work-text skolkovo-kids__content-work-text--item">
                            переориентировали контент в&nbsp;сторону &laquo;пользы&raquo;;
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="skolkovo-kids__content-work-text skolkovo-kids__content-work-text--item">
                            закрепили фирменный стиль сообщества.
                        </div>
                    </ScrollAnimation>
                </div>

                <div className="skolkovo-kids__content-work-images">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={300}
                    >
                        <img
                            className="skolkovo-kids__content-work-image"
                            src="/images/pic/skolkovo-kids/content4.png"
                            alt="content1"
                        />
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={800}
                    >
                        <img
                            className="skolkovo-kids__content-work-image"
                            src="/images/pic/skolkovo-kids/content5.png"
                            alt="content2"
                        />
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        delay={1300}
                    >
                        <img
                            className="skolkovo-kids__content-work-image"
                            src="/images/pic/skolkovo-kids/content6.png"
                            alt="content3"
                        />
                    </ScrollAnimation>
                </div>
            </div>
        </div>
    );
}

export default ContentWork;
